import { PLATFORM_ID, Provider } from '@angular/core';
import {
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';

import { msalInstanceFactory } from './config/msal-instance.factory';
import { msalInterceptorConfigFactory } from './config/msal-interceptor-config.factory';

export function provideMsal(): Provider[] {
  return [
    {
      provide: MSAL_INSTANCE,
      useFactory: msalInstanceFactory,
      deps: [PLATFORM_ID],
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: msalInterceptorConfigFactory,
    },
    MsalService,
    MsalBroadcastService,
    MsalInterceptor,
  ];
}
